if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// ===== START: Product Main Image Scroll Zoom , thanks CHAT GPT =====
function initProductMainImageScrollZoom() {
  const zoomSettings = {
    minZoom: 1,
    maxZoom: 1.2,
    smoothing: 0.12,
  };

  const isMobileViewport = () => window.matchMedia('(max-width: 995px)').matches;
  const mobileOnlyVideo = document.querySelector('.product-main-image.vid_mobile');
  const productMainImage =
    document.querySelector('.product-main-image.vid_desktop') ||
    document.querySelector('.product-main-image:not(.vid_mobile)');

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const initScrollZoomForElement = (element, shouldZoom) => {
    if (!element || element.dataset.scrollZoomInitialized === 'true') return;
    element.dataset.scrollZoomInitialized = 'true';

    let targetScale = zoomSettings.minZoom;
    let currentScale = zoomSettings.minZoom;
    let rafId = null;
    let isInViewport = false;

    const calculateTargetScale = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollY = window.scrollY || window.pageYOffset || 0;
      const zoomDistance = Math.max(element.offsetHeight * 0.9, viewportHeight * 0.8);
      const scrollProgress = clamp(scrollY / zoomDistance, 0, 1);

      return zoomSettings.minZoom + (zoomSettings.maxZoom - zoomSettings.minZoom) * scrollProgress;
    };

    const animateScale = () => {
      currentScale += (targetScale - currentScale) * zoomSettings.smoothing;
      element.style.transform = `scale(${currentScale.toFixed(4)})`;

      if (Math.abs(targetScale - currentScale) > 0.0005) {
        rafId = requestAnimationFrame(animateScale);
      } else {
        rafId = null;
      }
    };

    const updateZoom = () => {
      if (!isInViewport || !shouldZoom()) {
        targetScale = zoomSettings.minZoom;
        currentScale = zoomSettings.minZoom;
        element.style.transform = `scale(${zoomSettings.minZoom})`;
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        return;
      }

      targetScale = calculateTargetScale();
      if (!rafId) rafId = requestAnimationFrame(animateScale);
    };

    const onScroll = () => {
      if (!isInViewport || !shouldZoom()) return;
      updateZoom();
    };

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isInViewport = entry.isIntersecting;
          updateZoom();
        });
      },
      { threshold: 0 }
    );

    intersectionObserver.observe(element);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateZoom);
    updateZoom();
  };

  if (mobileOnlyVideo) {
    initScrollZoomForElement(mobileOnlyVideo, () => isMobileViewport());
  }

  if (!productMainImage) {
      return;
  }

  initScrollZoomForElement(productMainImage, () => !isMobileViewport() || !mobileOnlyVideo);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductMainImageScrollZoom);
} else {
  initProductMainImageScrollZoom();
}
// ===== END: Product Main Image Scroll Zoom =====
